import { render, staticRenderFns } from "./LogoAlt.html?vue&type=template&id=96b9bc30&scoped=true&"
import script from "./LogoAlt.ts?vue&type=script&lang=ts&"
export * from "./LogoAlt.ts?vue&type=script&lang=ts&"
import style0 from "./LogoAlt.scss?vue&type=style&index=0&id=96b9bc30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b9bc30",
  null
  
)

export default component.exports